import React, { useContext, useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import AdminContext from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import "./rejectpanel.css";
import {
  Back32,
  Cancel32,
  ProposalCreation32,
  submit,
} from "../../../../public/LoginImages/importimages";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";

import "./bill.css";
import GooglePagination from "../../styles/GooglePagination";
import { jwtDecode } from "jwt-decode";

const ProposalApproval = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (token) {
      try {
        // Decode the JWT token to get user details
        const decoded = jwtDecode(token);
        setUserData(decoded);
        console.log("Logged User Info:", decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);
  const { language, toggleLanguage, t } = useLanguage();
  const { id } = useParams();
  console.log("id", id);
  const Navigate = useNavigate();

  const urlLocation = useLocation();
  const urlType = urlLocation.state?.type;
  const context = useContext(AdminContext);

  const {
    GetProposalInwardsList,
    ProposalApprovalOperation,
    CreateToken,
    SecureFileFetching,
    Usermenu,
  } = context;

  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [remark, setRemark] = useState("");
  const [SelectedOptions, setSelectedOptions] = useState("All");
  const [searchParams, setSearchParams] = useSearchParams();
  const [grampanchayat, setgrampanchayat] = useState([]);
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(() => {
    const page = searchParams.get("page");
    return page ? parseInt(page) : 1;
  });

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
  const [FirstElement, setFirstElement] = useState({});

  const [hide, sethide] = useState(true);
  const [Etoken, SetEtoken] = useState(false);
  const [GenerateToken, SetGenerateToken] = useState(true);
  const [GenerateRejectToken, SetGenerateRejectToken] = useState(true);
  const [selectedWorkNames, setSelectedWorkNames] = useState([]);
  const [SelectedProposalDetail, setSelectedProposalDetail] = useState([]);
  const [adminData, setAdminData] = useState([]);

  const GetAdminData = async () => {
    try {
      let data = await Usermenu();
      console.log("data ------------", data);

      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return [];
      }

      const userData = data.Data; // ← Access Data object
      const menuList = data.result || []; // ← Access menu list

      setAdminData(userData);

      console.log("User Data:", userData);
      console.log("Menus:", menuList);
    } catch (err) {
      console.error("Error in GetAdminData:", err);
    }
  };
  useEffect(() => {
    GetAdminData();
  }, []);

  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };

  const query = new URLSearchParams(useLocation().search);
  const handleBack = () => {
    if (urlType == "State") {
      const returnPage = query.get("page") || 1;
      Navigate(
        `/AdminDashboard/ProposalInwardStateWise${returnPage ? `?page=${returnPage}` : ""}`,
      );
    } else {
      const returnPage = query.get("page") || 1;
      Navigate(
        `/AdminDashboard/ProposalInwardsList${returnPage ? `?page=${returnPage}` : ""}`,
      );
    }
  };

  const getTechnicalInwardsApprove = async () => {
    if (urlType == "State") {
      let data = await GetProposalInwardsList("ID", id, "State");
      console.log("data", data);
      if (data.length <= 0) {
        alert("No Proposal For Approval");
        Navigate("/AdminDashboard/ProposalInwardsList?page=1");
        return;
      }
      setTechnicalInwards(data);
      setFilteredBills(data);
      setFirstElement(data[0]);
      const grampanchayat = data.flatMap((item) =>
        JSON.parse(item.Gram_panchayat),
      );
      setgrampanchayat(JSON.stringify(grampanchayat));
    } else {
      let data = await GetProposalInwardsList("ID", id);
      console.log("data", data);
      if (data.length <= 0) {
        alert("No Proposal For Approval");
        Navigate("/AdminDashboard/ProposalInwardsList?page=1");
        return;
      }
      setTechnicalInwards(data);
      setFilteredBills(data);
      setFirstElement(data[0]);
      const grampanchayat = data.flatMap((item) =>
        JSON.parse(item.Gram_panchayat),
      );
      setgrampanchayat(JSON.stringify(grampanchayat));
    }
  };
  useEffect(() => {
    getTechnicalInwardsApprove();
  }, []);

  let inwardList = [];
  if (technicalInwards && technicalInwards.length > 0) {
    inwardList = technicalInwards;
  }

  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = technicalInwards.filter((bill) =>
      Object.values(bill).some((val) =>
        (val || "").toString().toLowerCase().includes(lowerSearchTerm),
      ),
    );
    setFilteredBills(filtered);
    // setCurrentPage(1);
  }, [searchTerm, technicalInwards]);

  useEffect(() => {
    const page = parseInt(searchParams.get("page")) || 1;
    if (totalPages > 0 && page > totalPages) {
      setCurrentPage(totalPages);
      setSearchParams({ page: totalPages });
    } else if (page < 1) {
      setCurrentPage(1);
      setSearchParams({ page: 1 });
    }
  }, [searchParams, totalPages, setSearchParams]);

  useEffect(() => {
    if (technicalInwards) {
      // let res = technicalInwards.filter((item) => item.Status == SelectedOptions);
      let res = SelectedOptions === "All" ? technicalInwards : technicalInwards.filter((item) => item.Status == SelectedOptions); 

      setFilteredBills(res);
    }
  }, [SelectedOptions, technicalInwards]);

  const handleCheckboxChange = (proposalId, workName) => {
    if (selectedBills.includes(proposalId)) {
      setSelectedBills(selectedBills.filter((id) => id !== proposalId));
      setSelectedWorkNames(
        selectedWorkNames.filter((name) => name !== workName),
      );
    } else {
      setSelectedBills([...selectedBills, proposalId]);
      setSelectedWorkNames([...selectedWorkNames, workName]);
    }
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedBills(currentBills.map((bill) => bill.ProposalID));
      setSelectedWorkNames(currentBills.map((bill) => bill.Work_name));
    } else {
      setSelectedBills([]);
      setSelectedWorkNames([]);
    }
  };

  const approveorrejectSelected = async (condition) => {
    console.log("approveorrejectSelected");
    if (selectedBills.length === 0) {
      alert("No Proposal selected for approval!");
      return;
    }
    if (condition == "Rejected" || condition == "SendBack") {
      const cleanRemark = remark.trim().replace(/\s+/g, " ");

      // ❌ If remark is empty after trimming
      if (!cleanRemark) {
        alert("Remark is required and cannot be empty!");
        return;
      }
    }
    setLoading(true);

    try {
      let response = await ProposalApprovalOperation(
        selectedBills,
        condition,
        remark,
        Etoken,
        selectedWorkNames,
        SelectedProposalDetail,
      ); // Call backend function
      if (response.message) {
        alert(response.message);

        // alert("Proposal Approve  !!");
        setRemark("");
        setRejectpanelhide(false);
        if (urlType == "State") {
          Navigate("/AdminDashboard/ProposalInwardStateWise?page=1");
        } else {
          Navigate("/AdminDashboard/ProposalInwardsList?page=1");
        }
      }
      if (response.error) {
        console.log("response.error:::", response.error);
        alert(response.error);
        // window.location.reload()
        getTechnicalInwardsApprove(); // Refresh the list after approval
      }
    } catch (error) {
      console.error("Error approving Proposal:", error);
      alert("An error occurred while approving bills.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // const ApproveSanction = async () => {
  //     const confirmed = window.confirm("Are you sure?");
  //     if (!confirmed) return;
  //     try {
  //         let data = await ProposalApprovalOperation(id);
  //         console.log("data");

  //         if (data?.message) {
  //             alert(data?.message)
  //             Navigate('/AdminDashboard/AdministrativeApprovalInwards')
  //         } else {
  //             alert("Administrative Approved Failed")
  //             Navigate('/AdminDashboard/AdministrativeApprovalInwards')
  //         }
  //     } catch (error) {
  //         console.error("Approval error:", error);
  //         alert("An error occurred during approval.");
  //     }

  // }

  useEffect(() => {
    if (selectedBills.length > 0) {
      const selectedDetails = technicalInwards.filter((item) =>
        selectedBills.includes(item.ProposalID),
      );
      setSelectedProposalDetail(selectedDetails);
    } else {
      setSelectedProposalDetail([]);
    }
  }, [selectedBills, technicalInwards]);

  const calculatedProposalAmount = currentBills.reduce(
    (sum, item) => sum + Number(item.Proposal_amount || 0),
    0,
  );

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, 0.7)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              border: "6px solid #f3f3f3",
              borderTop: "6px solid #007bff",
              borderRadius: "50%",
              width: "60px",
              height: "60px",
              animation: "spin 1s linear infinite",
            }}
          />
          <style>
            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
          </style>
        </div>
      )}

      {false && (
        <div
          style={{
            backgroundColor: "#EFF3F8",
            height: "90vh",
            overflowX: "hidden",
            overflowY: "scroll",
          }}
        >
          {FirstElement && (
            <div className="col-12">
              <div
                style={{
                  display: "grid",
                  justifyContent: "center",
                  marginTop: "5rem",
                  marginBottom: "5rem",
                }}
              >
                <div className="bill-container" id="container">
                  <div className="bill-header">
                    <div style={{ color: "red" }} className="municipal-council">
                      <h4>{t("Single Unified Portal")}</h4>
                    </div>
                    <div className="form">
                      {t("(Rural Development Department)")}
                    </div>
                    <div className="bill-title">{t("Zila Parishad")}</div>
                  </div>

                  <div
                    style={{
                      border: "1px black solid",
                      padding: "5px",
                      backgroundColor: "#e9f8f1",
                    }}
                  >
                    <div
                      className="innerheader"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <div>
                        {t("Proposal ID")} :{" "}
                        <span className="text-primary">{id}</span>{" "}
                        {t("Details")}
                      </div>
                    </div>
                  </div>
                  <div style={{ border: "1px black solid", display: "hidden" }}>
                    <div className="tax-table">
                      <table className="table table-striped tax-table-data">
                        <thead className="table-dark"></thead>
                        <tbody>
                          <tr>
                            <td style={{ width: "25%" }}>
                              <b>{t("Proposal UID")}</b>
                            </td>
                            <td align="center" style={{ width: "25%" }}>
                              <span id="lbl_genTax2">
                                {FirstElement?.workuniqueid}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "25%" }}>
                              <b>{t("Head Code")}</b>
                            </td>
                            <td align="center" style={{ width: "25%" }}>
                              <span id="lbl_genTax2">
                                {FirstElement?.HeadCode}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "25%" }}>
                              <b>{t("Year")}</b>{" "}
                            </td>
                            <td align="center" style={{ width: "25%" }}>
                              <span id="lbl_genTax2">
                                {FirstElement?.Proposal_year}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "25%" }}>
                              <b>{t("Taluka")}</b>
                            </td>
                            <td align="center" style={{ width: "25%" }}>
                              <span id="lbl_genTax2">
                                {FirstElement?.Taluka}
                              </span>
                            </td>
                          </tr>

                          {/* <tr>
                                                            <td style={{ width: "25%" }}><b>{t("Gram Panchayat")}</b></td>
                                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{FirstElement.Gram_panchayat}</span></td>
                                                        </tr> */}
                          <tr>
                            <td style={{ width: "25%" }}>
                              <b>{t("Constituency Name")}</b>{" "}
                            </td>
                            <td align="center" style={{ width: "25%" }}>
                              {" "}
                              <span id="lbl_genTax2">
                                {FirstElement?.Constituency_name}
                              </span>{" "}
                            </td>
                          </tr>
                          {/* <tr>
                                                    <td style={{ width: "25%" }}> <b>{t("Proposal Work Name")}</b></td>
                                                    <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{FirstElement.Work_name}</span></td>
                                                </tr> */}
                          <tr>
                            <td style={{ width: "25%" }}>
                              {" "}
                              <b>{t("Proposal File Number")}</b>
                            </td>
                            <td align="center" style={{ width: "25%" }}>
                              <span id="lbl_genTax2">
                                {FirstElement?.Proposal_fileNumber}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "25%" }}>
                              {" "}
                              <b>{t("Proposal Work Amount")}</b>
                            </td>
                            <td align="center" style={{ width: "25%" }}>
                              <span id="lbl_genTax2">
                                {calculatedProposalAmount}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "25%" }}>
                              {" "}
                              <b>{t("Proposal Copy")}</b>
                            </td>
                            <td align="center" style={{ width: "25%" }}>
                              {/* {
                                                                FirstElement.Proposal_copy ?
                                                                    (<a href={`${apiurl}/ProposalFile/${FirstElement?.Proposal_copy}`} target='_blank'>{FirstElement?.Proposal_copy}</a>)
                                                                    :
                                                                    (<p className='text-danger my-auto fw-bold'>No Copy</p>)
                                                            } */}
                              {FirstElement.Proposal_copy ? (
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    SecureFileFetching(
                                      `ProposalFile/${FirstElement?.Proposal_copy}`,
                                    );
                                  }}
                                  className="text-primary"
                                  style={{ cursor: "pointer" }}
                                >
                                  {FirstElement?.Proposal_copy}
                                </span>
                              ) : (
                                <p className="fw-bold text-danger my-auto">
                                  {t("No File")}
                                </p>
                              )}
                            </td>
                          </tr>

                          <tr>
                            <td style={{ width: "25%" }}>
                              {" "}
                              <b>{t("Additional Support Document")}</b>
                            </td>
                            <td align="center" style={{ width: "25%" }}>
                              <span id="lbl_genTax2">
                                {/* {
                                                                    FirstElement.Additional_suppDoc ?
                                                                        (<a href={`${apiurl}/ProposalFile/${FirstElement?.Additional_suppDoc}`} target='_blank'>{FirstElement?.Additional_suppDoc}</a>)
                                                                        :
                                                                        (<p className='text-danger my-auto fw-bold'>No Copy</p>)
                                                                } */}
                                {FirstElement.Additional_suppDoc ? (
                                  <span
                                    onClick={(e) => {
                                      e.preventDefault();
                                      SecureFileFetching(
                                        `ProposalFile/${FirstElement?.Additional_suppDoc}`,
                                      );
                                    }}
                                    className="text-primary"
                                    style={{ cursor: "pointer" }}
                                  >
                                    {FirstElement?.Additional_suppDoc}
                                  </span>
                                ) : (
                                  <p className="fw-bold text-danger my-auto">
                                    {t("No File")}
                                  </p>
                                )}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div
                    style={{
                      border: "1px black solid",
                      padding: "5px",
                      backgroundColor: "#e9f8f1",
                    }}
                  >
                    <div
                      className="innerheader"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <div>{t("Declaration")}</div>
                    </div>
                    <div className="note">
                      {t(
                        "I hereby declare that the information given above and in the enclosed documents is true to the best of my knowledge",
                      )}
                    </div>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "15px" }}>
                    <div>
                      {/* <button className='btn btn-success' onClick={() => ApproveSanction()}>Approve</button> */}
                      <button
                        className="btn btn-danger mx-3"
                        onClick={handleBack}
                      >
                        {t("Back")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-11 m-auto px-3 m-auto mb-5">
                {/* <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <h5 className='my-auto fw-bold'>
                                        <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                                        <span className='my-auto'>Proposal Approval</span>
                                    </h5>
    
                                    <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                                        <img
                                            src="/Search32.png"
                                            alt="Search Icon"
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "10px",
                                                transform: "translateY(-50%)",
                                                width: "16px",
                                                height: "16px",
                                                opacity: 0.6
                                            }}
                                        />
                                        <input
                                            type="text"
                                            placeholder="Search Here"
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            value={searchTerm}
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px 8px 32px", // left padding makes space for icon
                                                border: "1px solid #ccc",
                                                borderRadius: "8px",
                                                backgroundColor: "#f1f6fc",
                                                fontSize: "14px",
                                                color: "#333",
                                                boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                                outline: "none"
                                            }}
                                        />
                                    </div>
                                </div> */}

                <div className="col-12 my-4">
                  <div
                    className="col-12 py-4 "
                    style={{
                      background: "linear-gradient(to right, #c8d0e3, #b7dff5)",
                      borderRadius: "10px",
                    }}
                  >
                    <div className="col-8 m-auto">
                      <div className="row align-items-center">
                        <div className="col-4 text-end">
                          <label className="fw-bold">
                            {t("Select Status")}
                          </label>
                        </div>

                        <div className="col-6">
                          <select
                            className="w-100 py-2 px-3"
                            style={{
                              border: "none",
                              borderRadius: "6px",
                              outline: "none",
                              fontSize: "14px",
                              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                            }}
                            onChange={(e) => setSelectedOptions(e.target.value)}
                          >
                            <option value="Pending">{t("Approve")}</option>
                            <option value="SendBack">{t("Send Back")}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {SelectedOptions === "Pending" && (
                  <div
                    className="m-auto"
                    style={{
                      width: "98%",
                      backgroundColor: "white",
                      padding: "30px 30px",
                      boxShadow: "0px 0px 5px 1px #c7c9cc",
                      borderRadius: "20px",
                    }}
                  >
                    <div
                      className="col-12 pb-3 px-1"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h5 className="my-auto fw-bold">
                        {/* <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' /> */}
                        <span className="my-auto">
                          {t("Proposal Works for Approval")}
                        </span>
                      </h5>

                      <div
                        style={{
                          position: "relative",
                          width: "250px",
                          marginRight: "10px",
                        }}
                      >
                        <img
                          src="/Search32.png"
                          alt="Search Icon"
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            width: "16px",
                            height: "16px",
                            opacity: 0.6,
                          }}
                        />
                        <input
                          type="text"
                          placeholder="Search Here"
                          onChange={(e) => setSearchTerm(e.target.value)}
                          value={searchTerm}
                          style={{
                            width: "100%",
                            padding: "8px 12px 8px 32px", // left padding makes space for icon
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            backgroundColor: "#f1f6fc",
                            fontSize: "14px",
                            color: "#333",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                            outline: "none",
                          }}
                        />
                      </div>
                    </div>

                    <div
                      className="col-12 tableDesign"
                      style={{ background: "#2C78DB" }}
                    >
                      <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                        <table
                          className="m-0 p-0"
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <thead>
                            <tr
                              style={{
                                color: "white",
                                border: "none",
                                height: "3rem",
                                fontSize: "18px",
                              }}
                            >
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "70px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  onChange={handleSelectAll}
                                  checked={
                                    selectedBills.length > 0 &&
                                    selectedBills.length === currentBills.length
                                  }
                                  className="my-auto"
                                  style={{ height: "1rem", width: "1rem" }}
                                />
                              </th>
                              {/* <th style={{ width: "8%" }}>View</th> */}
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "250px",
                                }}
                              >
                                {t("Proposal Work Name")}
                              </th>
                              {/* <th style={{ width: "10%" }}>Proposal ID</th> */}
                              {/* <th style={{ padding: "7px 10px", minWidth: "220px" }}>HeadCode</th> */}
                              {/* <th style={{ padding: "7px 10px", minWidth: "100px" }}>Proposal Year</th> */}
                              {/* <th style={{ width: "10%" }}>Scheme Name</th> */}
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                              >
                                {t("District")}
                              </th>
                              {/* <th style={{ padding: "7px 10px", minWidth: "200px" }}>{t("Gram Panchayat")}</th> */}
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "140px",
                                }}
                              >
                                {t("Class Of Work")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "220px",
                                }}
                              >
                                {t("Type of Work")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "140px",
                                }}
                              >
                                {t("Village Road")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "140px",
                                }}
                              >
                                {t("Other District Road")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "140px",
                                }}
                              >
                                {t("Proposed Length")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "140px",
                                }}
                              >
                                {t("Remark")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "140px",
                                }}
                              >
                                {t("Proposal Work Amount")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                              >
                                {t("Edit")}
                              </th>
                              {/* <th style={{ width: "10%" }}>Location</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {currentBills.length <= 0 ? (
                              <tr>
                                <td
                                  colSpan="12"
                                  style={{
                                    textAlign: "center",
                                    padding: "20px",
                                    backgroundColor: "#f9f9f9",
                                  }}
                                >
                                  {t("No data available")}
                                </td>
                              </tr>
                            ) : (
                              currentBills?.map((technicalInwards, index) => {
                                const bgColor =
                                  index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                  <tr
                                    style={{
                                      backgroundColor: bgColor,
                                      fontSize: "18px",
                                      fontWeight: "500",
                                    }}
                                    key={index}
                                  >
                                    <td style={{ textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        className="my-auto"
                                        style={{
                                          height: "1rem",
                                          width: "1rem",
                                        }}
                                        checked={selectedBills.includes(
                                          technicalInwards.ProposalID,
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            technicalInwards.ProposalID,
                                            technicalInwards.Work_name,
                                          )
                                        }
                                      />
                                    </td>
                                    {/* <td className='py-2'>
                                                                                    <button
                                                                                        onClick={() => na(`/AdminDashboard/ProposalApprove/${technicalInwards.ProposalID}?page=${currentPage}`)}
                                                                                        className='m-auto text-center'
                                                                                        style={{
                                                                                            width: "3.8rem", fontWeight: "600", padding: "7px 3px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
                                                                                            background: 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
                                                                                            color: 'white', borderRadius: '8px',
                                                                                        }}
                                                                                    > <img src='/view32.png' style={{ width: '0.9rem', height: "0.9rem", filter: 'brightness(0) invert(1)' }} />
                                                                                        View
                                                                                    </button>
                                                                                </td> */}
                                    <td className="py-2">
                                      {technicalInwards.Work_name}
                                    </td>
                                    {/* <td className='py-2'>{technicalInwards.HeadCode}</td> */}
                                    {/* <td className='py-2'>{technicalInwards.Proposal_year}</td> */}
                                    {/* <td className='py-2'>{technicalInwards.SchemeName}</td> */}
                                    <td className="py-2">
                                      {technicalInwards.District}
                                    </td>
                                    {/* <td className='py-2'>
                                                                                            {technicalInwards.Gram_panchayat
                                                                                                ? JSON.parse(technicalInwards.Gram_panchayat).join(", ")
                                                                                                : ""}
                                                                                        </td> */}
                                    <td className="py-2">
                                      {technicalInwards.classOfWork}
                                    </td>
                                    <td className="py-2">
                                      {technicalInwards.typeOfWork}
                                    </td>
                                    <td className="py-2">
                                      {technicalInwards.roadCategory}
                                    </td>
                                    <td className="py-2">
                                      {technicalInwards.roadNumber}
                                    </td>
                                    <td className="py-2">
                                      {technicalInwards.proposedLength}
                                    </td>
                                    {/* <td className="py-2">
                                      {technicalInwards.workRemark}
                                    </td> */}
                                    <td className="py-2">
    {technicalInwards.Status === "SendBack"
        ? technicalInwards.Remark?.trim() || "-"
        : technicalInwards.workRemark?.trim() || "-"}
</td>
                                    <td
                                      style={{ padding: "8px" }}
                                    >{`${technicalInwards.Proposal_amount}`}</td>
                                    <td className="py-2">
                                      <button
                                        onClick={() =>
                                          Navigate(
                                            `/AdminDashboard/EditProposal/${technicalInwards.ProposalID}`,
                                            {
                                              state: {
                                                type: urlType,
                                              },
                                            },
                                          )
                                        }
                                        className="m-auto text-center"
                                        style={{
                                          width: "4rem",
                                          fontWeight: "700",
                                          padding: "7px 3px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          gap: "0.1rem",
                                          background:
                                            "linear-gradient(to right, #2E7D32, #43A047, #4CAF50, #66BB6A)",
                                          color: "white",
                                          borderRadius: "4px",
                                        }}
                                      >
                                        {t("Edit")}
                                      </button>
                                    </td>
                                    {/* <td style={{ padding: '8px' }}>
                                                                    <button
                                                                        onClick={() => nav(`/AdminDashboard/ShowMapProposal/${encodeURIComponent(technicalInwards.Work_name)}`)}
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '0.4rem',
                                                                            padding: '6px 10px',
                                                                            fontWeight: '700',
                                                                            fontSize: '13px',
                                                                            color: '#357EDC',
                                                                            backgroundColor: '#E8F0FE',
                                                                            borderRadius: '6px',
                                                                            cursor: 'pointer',
                                                                            transition: 'all 0.2s ease-in-out'
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src='/Go-To-Map32.png'
                                                                            alt='Go to Map'
                                                                            style={{ width: '1rem', height: '1rem' }}
                                                                        />
                                                                        Go to Map
                                                                    </button>
                                                                </td> */}
                                  </tr>
                                );
                              })
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="col-12 mt-3">
                      <div
                        className="my-2 d-flex justify-content-between align-items-center"
                        style={{ flexWrap: "wrap" }}
                      >
                        <p
                          className="text-gray-600"
                          style={{ fontSize: "14px", margin: 0 }}
                        >
                          {t("Showing")}{" "}
                          {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
                          {t("to")}{" "}
                          {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
                          {t("of")} {filteredBills?.length} {t("entries")}
                        </p>
                        <div className="col-6 text-end">
                          {/* First Page Button */}
                          <button
                            onClick={() => setCurrentPage(1)}
                            disabled={currentPage === 1}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "20px",
                              width: "2rem",
                            }}
                          >
                            &laquo;
                          </button>
                          {/* Previous Button */}
                          <button
                            onClick={() => setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "20px",
                              borderLeft: "none",
                              width: "2rem",
                            }}
                          >
                            &lt;
                          </button>

                          <button
                            style={{
                              background:
                                "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                              color: "white",
                              cursor: "pointer",
                              fontSize: "20px",
                              width: "2.4rem",
                              border: "1px solid lightgrey",
                              borderLeft: "none",
                            }}
                          >
                            {currentPage}
                          </button>
                          {/* Next Button */}
                          <button
                            onClick={() => setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "20px",
                              borderLeft: "none",
                              width: "2rem",
                            }}
                          >
                            &gt;
                          </button>
                          {/* Last Page Button */}
                          <button
                            onClick={() => setCurrentPage(totalPages)}
                            disabled={currentPage === totalPages}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "20px",
                              borderLeft: "none",
                              width: "2rem",
                            }}
                          >
                            &raquo;
                          </button>
                        </div>

                        <div
                          className="col-6 text-start"
                          style={{ display: "flex", justifyContent: "left" }}
                        >
                          <button
                            onClick={() => approveorrejectSelected("Approved")}
                            disabled={
                              selectedBills.length <= 0 ? true : loading
                            }
                            className="ms-0"
                            // onClick={(e) => { SetGenerateToken(false) }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.3rem",
                              margin: "12px",
                              padding: "8px 10px",
                              fontWeight: "600",
                              backgroundColor:
                                selectedBills.length <= 0
                                  ? "rgba(141, 141, 141, 0.97)"
                                  : "#39B54A",
                              color: "white",
                              borderRadius: "8px",
                              cursor:
                                selectedBills.length <= 0
                                  ? "not-allowed"
                                  : loading
                                    ? "not-allowed"
                                    : "pointer",
                            }}
                          >
                            <img
                              src="/Approve-Selected32.png"
                              style={{
                                width: "1rem",
                                height: "1rem",
                                filter: "brightness(0) invert(1)",
                              }}
                            />{" "}
                            {loading
                              ? t("Processing...")
                              : t("Approve Selected")}
                          </button>

                          <button
                            onClick={() => setRejectpanelhide(2)}
                            // onClick={(e) => { SetGenerateRejectToken(false) }}
                            disabled={
                              selectedBills.length <= 0 ? true : loading
                            }
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.3rem",
                              margin: "12px",
                              padding: "8px 10px",
                              fontWeight: "600",
                              background:
                                selectedBills.length <= 0
                                  ? "rgba(141, 141, 141, 0.97)"
                                  : "#C1272D",
                              color: "white",
                              borderRadius: "8px",
                              cursor:
                                selectedBills.length <= 0
                                  ? "not-allowed"
                                  : loading
                                    ? "not-allowed"
                                    : "pointer",
                            }}
                          >
                            <img
                              src="/Reject-Selected32.png"
                              style={{
                                width: "1rem",
                                height: "1rem",
                                filter: "brightness(0) invert(1)",
                              }}
                            />{" "}
                            {loading
                              ? t("Processing...")
                              : t("Reject Selected")}
                          </button>

                          {adminData.Role !== "Deputy Engineer" &&
                            adminData.Role !== "RDD Section Officer" && (
                              <button
                                onClick={() => setRejectpanelhide(3)}
                                disabled={
                                  selectedBills.length <= 0 ? true : loading
                                }
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "3px",
                                  margin: "12px",
                                  padding: "8px 10px",
                                  fontWeight: "600",
                                  background:
                                    selectedBills.length <= 0
                                      ? "rgba(141, 141, 141, 0.97)"
                                      : "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                  color: "white",
                                  borderRadius: "8px",
                                  cursor:
                                    selectedBills.length <= 0
                                      ? "not-allowed"
                                      : loading
                                        ? "not-allowed"
                                        : "pointer",
                                }}
                              >
                                <img
                                  src="/Send-Back-Selected32.png"
                                  style={{
                                    width: "1rem",
                                    height: "1rem",
                                    filter: "brightness(0) invert(1)",
                                  }}
                                />{" "}
                                {loading
                                  ? t("Processing...")
                                  : t("Send Back Selected")}
                              </button>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {SelectedOptions === "SendBack" && (
                  <div
                    className="m-auto"
                    style={{
                      width: "98%",
                      backgroundColor: "white",
                      padding: "30px 30px",
                      boxShadow: "0px 0px 5px 1px #c7c9cc",
                      borderRadius: "20px",
                    }}
                  >
                    <div
                      className="col-12 tableDesign"
                      style={{ background: "#2C78DB" }}
                    >
                      <table
                        className="m-0 p-0"
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "12px",
                            }}
                          >
                            <th style={{ width: "4%", textAlign: "center" }}>
                              <input
                                type="checkbox"
                                onChange={handleSelectAll}
                                checked={
                                  selectedBills.length > 0 &&
                                  selectedBills.length === currentBills.length
                                }
                                className="my-auto"
                                style={{ height: "1rem", width: "1rem" }}
                              />
                            </th>
                            <th style={{ width: "10%" }}>{t("Edit")}</th>
                            <th style={headerStyle}>{t("Proposal Name")}</th>
                            <th style={headerStyle}>{t("HeadCode")}</th>
                            <th style={headerStyle}>{t("Proposal Year")}</th>
                            <th style={headerStyle}>{t("District")}</th>
                            <th style={headerStyle}>{t("Gram Panchayat")}</th>
                            <th style={headerStyle}>{t("Work Amount")}</th>
                            <th style={headerStyle}>{t("Remark")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentBills.length <= 0 ? (
                            <tr>
                              <td
                                colSpan="12"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {t("No data available")}
                              </td>
                            </tr>
                          ) : (
                            currentBills?.map((technicalInwards, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                              return (
                                <tr
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "18px",
                                    fontWeight: "500",
                                  }}
                                  key={index}
                                >
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      className="my-auto"
                                      style={{ height: "1rem", width: "1rem" }}
                                      checked={selectedBills.includes(
                                        technicalInwards.ProposalID,
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          technicalInwards.ProposalID,
                                          technicalInwards.Work_name,
                                        )
                                      }
                                    />
                                  </td>
                                  <td className="py-2">
                                    <button
                                      onClick={() =>
                                        Navigate(
                                          `/AdminDashboard/EditProposal/${technicalInwards.ProposalID}`,
                                        )
                                      }
                                      className="m-auto text-center"
                                      style={{
                                        width: "4rem",
                                        fontWeight: "600",
                                        padding: "7px 3px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "0.1rem",
                                        background:
                                          "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                        color: "white",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      {t("Edit")}
                                    </button>
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.Work_name}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.HeadCode}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.Proposal_year}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.District}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.Gram_panchayat}
                                  </td>
                                  <td style={{ padding: "8px" }}>
  ₹{Number(technicalInwards.Proposal_amount || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}
</td>
                                  {/* <td
                                    style={{ padding: "8px" }}
                                  >{`${technicalInwards.workRemark}`}</td> */}
                                  <td className="py-2">
    {technicalInwards.Status === "SendBack"
        ? technicalInwards.Remark?.trim() || "-"
        : technicalInwards.workRemark?.trim() || "-"}
</td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="col-12 mt-3">
                      <div
                        className="my-2 d-flex justify-content-between align-items-center"
                        style={{ flexWrap: "wrap" }}
                      >
                        <p
                          className="text-gray-600"
                          style={{ fontSize: "14px", margin: 0 }}
                        >
                          {t("Showing")}{" "}
                          {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
                          {t("to")}{" "}
                          {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
                          {t("of")} {filteredBills?.length} {t("entries")}
                        </p>
                        <div className="col-6 text-end">
                          {/* First Page Button */}
                          <button
                            onClick={() => setCurrentPage(1)}
                            disabled={currentPage === 1}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "20px",
                              width: "2rem",
                            }}
                          >
                            &laquo;
                          </button>
                          {/* Previous Button */}
                          <button
                            onClick={() => setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "20px",
                              borderLeft: "none",
                              width: "2rem",
                            }}
                          >
                            &lt;
                          </button>

                          <button
                            style={{
                              background:
                                "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                              color: "white",
                              cursor: "pointer",
                              fontSize: "20px",
                              width: "2.4rem",
                              border: "1px solid lightgrey",
                              borderLeft: "none",
                            }}
                          >
                            {currentPage}
                          </button>
                          {/* Next Button */}
                          <button
                            onClick={() => setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "20px",
                              borderLeft: "none",
                              width: "2rem",
                            }}
                          >
                            &gt;
                          </button>
                          {/* Last Page Button */}
                          <button
                            onClick={() => setCurrentPage(totalPages)}
                            disabled={currentPage === totalPages}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "20px",
                              borderLeft: "none",
                              width: "2rem",
                            }}
                          >
                            &raquo;
                          </button>
                        </div>

                        <div
                          className="col-6 text-start"
                          style={{ display: "flex", justifyContent: "left" }}
                        >
                          <button
                            onClick={() => approveorrejectSelected("Approved")}
                            disabled={
                              selectedBills.length <= 0 ? true : loading
                            }
                            className="ms-0"
                            // onClick={(e) => { SetGenerateToken(false) }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.3rem",
                              margin: "12px",
                              padding: "8px 10px",
                              fontWeight: "600",
                              backgroundColor:
                                selectedBills.length <= 0
                                  ? "rgba(141, 141, 141, 0.97)"
                                  : "#39B54A",
                              color: "white",
                              borderRadius: "8px",
                              cursor:
                                selectedBills.length <= 0
                                  ? "not-allowed"
                                  : loading
                                    ? "not-allowed"
                                    : "pointer",
                            }}
                          >
                            <img
                              src="/Approve-Selected32.png"
                              style={{
                                width: "1rem",
                                height: "1rem",
                                filter: "brightness(0) invert(1)",
                              }}
                            />{" "}
                            {loading
                              ? t("Processing...")
                              : t("Approve Selected")}
                          </button>

                          <button
                            onClick={() => setRejectpanelhide(2)}
                            // onClick={(e) => { SetGenerateRejectToken(false) }}
                            disabled={
                              selectedBills.length <= 0 ? true : loading
                            }
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.3rem",
                              margin: "12px",
                              padding: "8px 10px",
                              fontWeight: "600",
                              background:
                                selectedBills.length <= 0
                                  ? "rgba(141, 141, 141, 0.97)"
                                  : "#C1272D",
                              color: "white",
                              borderRadius: "8px",
                              cursor:
                                selectedBills.length <= 0
                                  ? "not-allowed"
                                  : loading
                                    ? "not-allowed"
                                    : "pointer",
                            }}
                          >
                            <img
                              src="/Reject-Selected32.png"
                              style={{
                                width: "1rem",
                                height: "1rem",
                                filter: "brightness(0) invert(1)",
                              }}
                            />{" "}
                            {loading
                              ? t("Processing...")
                              : t("Reject Selected")}
                          </button>
                          {adminData.Role !== "Deputy Engineer" &&
                            adminData.Role !== "RDD Section Officer" && (
                              <button
                                onClick={() => setRejectpanelhide(3)}
                                disabled={
                                  selectedBills.length <= 0 ? true : loading
                                }
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "3px",
                                  margin: "12px",
                                  padding: "8px 10px",
                                  fontWeight: "600",
                                  background:
                                    selectedBills.length <= 0
                                      ? "rgba(141, 141, 141, 0.97)"
                                      : "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                  color: "white",
                                  borderRadius: "8px",
                                  cursor:
                                    selectedBills.length <= 0
                                      ? "not-allowed"
                                      : loading
                                        ? "not-allowed"
                                        : "pointer",
                                }}
                              >
                                <img
                                  src="/Send-Back-Selected32.png"
                                  style={{
                                    width: "1rem",
                                    height: "1rem",
                                    filter: "brightness(0) invert(1)",
                                  }}
                                />{" "}
                                {loading
                                  ? t("Processing...")
                                  : t("Send Back Selected")}
                              </button>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {rejectPanelhide === 2 && (
            <div className="col-12 RejectPanelContainer">
              <div className="Rejectpanel">
                <form action="">
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label className="fw-bold">
                          {t("Remark")} <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-8">
                        <textarea
                          name=""
                          id=""
                          placeholder={t("Enter Remark")}
                          value={remark}
                          onChange={(e) =>
                            setRemark(e.target.value.replace(/^\s+/, ""))
                          }
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="col-12 ms-auto my-4">
                  <div className="row">
                    <div className="col-9 m-auto">
                      <div
                        className="col-12"
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            background:
                              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                            width: "5rem",
                            height: "2rem",
                            fontSize: "18px",
                          }}
                          onClick={() => approveorrejectSelected("Rejected")}
                        >
                          <img src={submit} style={{ width: "15px" }} /> Reject
                        </button>
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor: "#f1594c",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                          }}
                          onClick={() => window.location.reload()}
                        >
                          {" "}
                          <img src={Cancel32} style={{ width: "17px" }} />
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {rejectPanelhide === 3 && (
            <div className="col-12 RejectPanelContainer">
              <div className="Rejectpanel">
                <form action="">
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label className="fw-bold">
                          {t("Remark")} <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-8">
                        <textarea
                          name=""
                          id=""
                          placeholder={t("Enter Remark")}
                          value={remark}
                          onChange={(e) =>
                            setRemark(e.target.value.replace(/^\s+/, ""))
                          }
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="col-12 ms-auto my-4">
                  <div className="row">
                    {/* <div className="col-3"></div> */}
                    <div className="col-9 m-auto">
                      <div
                        className="col-12"
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            background:
                              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                            width: "8rem",
                            height: "2rem",
                            fontSize: "18px",
                          }}
                          onClick={() => approveorrejectSelected("SendBack")}
                        >
                          <img src={submit} style={{ width: "15px" }} /> Send
                          Back
                        </button>
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor: "#f1594c",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                          }}
                          onClick={() => window.location.reload()}
                        >
                          {" "}
                          <img src={Cancel32} style={{ width: "17px" }} />
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <div
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        {FirstElement && (
          <div className="col-12">
            <div
              style={{
                display: "grid",
                justifyContent: "center",
                marginTop: "5rem",
                marginBottom: "5rem",
              }}
            >
              <div className="bill-container" id="container">
                <div className="bill-header">
                  <div style={{ color: "red" }} className="municipal-council">
                    <h4>{t("Single Unified Portal")}</h4>
                  </div>
                  <div className="form">
                    {t("(Rural Development Department)")}
                  </div>
                  <div className="bill-title">{t("Zila Parishad")}</div>
                </div>

                <div
                  style={{
                    border: "1px black solid",
                    padding: "5px",
                    backgroundColor: "#e9f8f1",
                  }}
                >
                  <div
                    className="innerheader"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div>
                      {t("Proposal ID")} :{" "}
                      <span className="text-primary">{id}</span> {t("Details")}
                    </div>
                  </div>
                </div>
                <div style={{ border: "1px black solid", display: "hidden" }}>
                  <div className="tax-table">
                    <table className="table table-striped tax-table-data">
                      <thead className="table-dark"></thead>
                      <tbody>
                        <tr>
                          <td style={{ width: "25%" }}>
                            <b>{t("Proposal UID")}</b>
                          </td>
                          <td align="center" style={{ width: "25%" }}>
                            <span id="lbl_genTax2">
                              {FirstElement?.workuniqueid}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "25%" }}>
                            <b>{t("Head Code")}</b>
                          </td>
                          <td align="center" style={{ width: "25%" }}>
                            <span id="lbl_genTax2">
                              {FirstElement?.HeadCode}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "25%" }}>
                            <b>{t("Year")}</b>{" "}
                          </td>
                          <td align="center" style={{ width: "25%" }}>
                            <span id="lbl_genTax2">
                              {FirstElement?.Proposal_year}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "25%" }}>
                            <b>{t("Taluka")}</b>
                          </td>
                          <td align="center" style={{ width: "25%" }}>
                            <span id="lbl_genTax2">{FirstElement?.Taluka}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "25%" }}>
                            <b>{t("Gram Panchayat")}</b>
                          </td>
                          <td
                            align="center"
                            style={{
                              width: "25%",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {grampanchayat}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "25%" }}>
                            <b>{t("Constituency Name")}</b>{" "}
                          </td>
                          <td align="center" style={{ width: "25%" }}>
                            {" "}
                            <span id="lbl_genTax2">
                              {FirstElement?.Constituency_name}
                            </span>{" "}
                          </td>
                        </tr>
                        {/* <tr>
                                                            <td style={{ width: "25%" }}> <b>{t("Proposal Work Name")}</b></td>
                                                            <td align="center" style={{ width: "25%" }}><span id="lbl_genTax2">{FirstElement.Work_name}</span></td>
                                                        </tr> */}
                        <tr>
                          <td style={{ width: "25%" }}>
                            {" "}
                            <b>{t("Proposal File Number")}</b>
                          </td>
                          <td align="center" style={{ width: "25%" }}>
                            <span id="lbl_genTax2">
                              {FirstElement?.Proposal_fileNumber}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "25%" }}>
                            {" "}
                            <b>{t("Proposal Work Amount")}</b>
                          </td>
                          <td align="center" style={{ width: "25%" }}>
                            <span id="lbl_genTax2">{`${calculatedProposalAmount}`}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "25%" }}>
                            {" "}
                            <b>{t("Proposal Copy")}</b>
                          </td>
                          <td align="center" style={{ width: "25%" }}>
                            {FirstElement.Proposal_copy ? (
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  SecureFileFetching(
                                    `ProposalFile/${FirstElement?.Proposal_copy}`,
                                  );
                                }}
                                className="text-primary"
                                style={{ cursor: "pointer" }}
                              >
                                {FirstElement?.Proposal_copy}
                              </span>
                            ) : (
                              <p className="fw-bold text-danger my-auto">
                                {t("No File")}
                              </p>
                            )}
                          </td>
                        </tr>

                        {urlType == "Proposal" && (
                          <tr>
                            <td style={{ width: "25%" }}>
                              {" "}
                              <b>{t("Additional Support Document")}</b>
                            </td>
                            <td align="center" style={{ width: "25%" }}>
                              <span id="lbl_genTax2">
                                {FirstElement.Additional_suppDoc ? (
                                  <span
                                    onClick={(e) => {
                                      e.preventDefault();
                                      SecureFileFetching(
                                        `ProposalFile/${FirstElement?.Additional_suppDoc}`,
                                      );
                                    }}
                                    className="text-primary"
                                    style={{ cursor: "pointer" }}
                                  >
                                    {FirstElement?.Additional_suppDoc}
                                  </span>
                                ) : (
                                  <p className="fw-bold text-danger my-auto">
                                    {t("No File")}
                                  </p>
                                )}
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  style={{
                    border: "1px black solid",
                    padding: "5px",
                    backgroundColor: "#e9f8f1",
                  }}
                >
                  <div
                    className="innerheader"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div>Declaration</div>
                  </div>
                  <div className="note">
                    {t(
                      "I hereby declare that the information given above and in the enclosed documents is true to the best of my knowledge",
                    )}
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", marginTop: "15px" }}>
                  <div>
                    {/* <button className='btn btn-success' onClick={() => ApproveSanction()}>Approve</button> */}
                    <button
                      className="btn btn-danger mx-3"
                      onClick={handleBack}
                    >
                      {t("Back")}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-11 m-auto px-3 m-auto mb-5">
              {/* <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <h5 className='my-auto fw-bold'>
                                                <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                                                <span className='my-auto'>Proposal Approval</span>
                                            </h5>
            
                                            <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                                                <img
                                                    src="/Search32.png"
                                                    alt="Search Icon"
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "10px",
                                                        transform: "translateY(-50%)",
                                                        width: "16px",
                                                        height: "16px",
                                                        opacity: 0.6
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="Search Here"
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                    value={searchTerm}
                                                    style={{
                                                        width: "100%",
                                                        padding: "8px 12px 8px 32px", // left padding makes space for icon
                                                        border: "1px solid #ccc",
                                                        borderRadius: "8px",
                                                        backgroundColor: "#f1f6fc",
                                                        fontSize: "14px",
                                                        color: "#333",
                                                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                                        outline: "none"
                                                    }}
                                                />
                                            </div>
                                        </div> */}

              <div className="col-12 my-4">
                <div
                  className="col-12 py-4 "
                  style={{
                    background: "linear-gradient(to right, #c8d0e3, #b7dff5)",
                    borderRadius: "10px",
                  }}
                >
                  <div className="col-8 m-auto">
                    <div className="row align-items-center">
                      <div className="col-4 text-end">
                        <label className="fw-bold">{t("Select Status")}</label>
                      </div>

                      <div className="col-6">
                        <select
                          className="w-100 py-2 px-3"
                          style={{
                            border: "none",
                            borderRadius: "6px",
                            outline: "none",
                            fontSize: "14px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                          }}
                          onChange={(e) => setSelectedOptions(e.target.value)}
                        >
                          <option value="All">{t("All")}</option>
                          <option value="Pending">{t("Approve")}</option>
                          {adminData.Role !== "Additional CEO" && (
                            <option value="SendBack">{t("Send Back")}</option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* {SelectedOptions === "Pending" && ( */}
              {(SelectedOptions === "Pending" || SelectedOptions === "All") && (
                <div
                  className="m-auto"
                  style={{
                    width: "98%",
                    backgroundColor: "white",
                    padding: "30px 30px",
                    boxShadow: "0px 0px 5px 1px #c7c9cc",
                    borderRadius: "20px",
                  }}
                >
                  <div
                    className="col-12 pb-3 px-1"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h5 className="my-auto fw-bold">
                      {/* <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' /> */}
                      <span className="my-auto">
                        {t("Proposal Works for Approval")}
                      </span>
                    </h5>

                    <div
                      style={{
                        position: "relative",
                        width: "250px",
                        marginRight: "10px",
                      }}
                    >
                      <img
                        src="/Search32.png"
                        alt="Search Icon"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          width: "16px",
                          height: "16px",
                          opacity: 0.6,
                        }}
                      />
                      <input
                        type="text"
                        placeholder={t("Search Here")}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        value={searchTerm}
                        style={{
                          width: "100%",
                          padding: "8px 12px 8px 32px", // left padding makes space for icon
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f1f6fc",
                          fontSize: "14px",
                          color: "#333",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                          outline: "none",
                        }}
                      />
                    </div>
                  </div>

                  <div
                    className="col-12 tableDesign"
                    style={{ background: "#2C78DB" }}
                  >
                    <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                      {/* <table
                        className="m-0 p-0"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <thead>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                            }}
                          >
                            <th style={{ padding: "6px" }}>Sr.No.</th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "70px" }}
                            >
                              <input
                                type="checkbox"
                                onChange={handleSelectAll}
                                checked={
                                  selectedBills.length > 0 &&
                                  selectedBills.length === currentBills.length
                                }
                                className="my-auto"
                                style={{ height: "1rem", width: "1rem" }}
                              />
                            </th>
                            <th style={{ width: "8%" }}>View</th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "250px" }}
                            >
                              {t("Work Name")}
                            </th>
                            {userData?.RoleID !== 41 && (
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "100px",
                                }}
                              >
                                Job ID
                              </th>
                            )}
                            <th style={{ width: "10%" }}>Proposal ID</th>
                            <th style={{ padding: "7px 10px", minWidth: "220px" }}>HeadCode</th>
                            <th style={{ padding: "7px 10px", minWidth: "100px" }}>Proposal Year</th>
                            <th style={{ width: "10%" }}>Scheme Name</th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "150px" }}
                            >
                              {t("District")}
                            </th>
                            <th style={{ padding: "7px 10px", minWidth: "200px" }}>{t("Gram Panchayat")}</th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "140px" }}
                            >
                              {t("Class Of Work")}
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "220px" }}
                            >
                              {t("Type of Work")}
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "140px" }}
                            >
                              {t("Road Category")}
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "140px" }}
                            >
                              {t("Road Number")}
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "140px" }}
                            >
                              {t("Proposed Length(in Km)")}
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "140px" }}
                            >
                              {t("Remark")}
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "140px" }}
                            >
                              {t("Work Amount")}
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "150px" }}
                            >
                              {t("Edit")}
                            </th>
                            <th style={{ width: "10%" }}>Location</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentBills.length <= 0 ? (
                            <tr>
                              <td
                                colSpan="12"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {t("No data available")}
                              </td>
                            </tr>
                          ) : (
                            currentBills?.map((technicalInwards, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                              return (
                                <tr
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "18px",
                                    fontWeight: "500",
                                  }}
                                  key={index}
                                >
                                  <td>{index + 1}</td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      className="my-auto"
                                      style={{ height: "1rem", width: "1rem" }}
                                      checked={selectedBills.includes(
                                        technicalInwards.ProposalID,
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          technicalInwards.ProposalID,
                                          technicalInwards.Work_name,
                                        )
                                      }
                                    />
                                  </td>
                                  <td className='py-2'>
                                                                                            <button
                                                                                                onClick={() => na(`/AdminDashboard/ProposalApprove/${technicalInwards.ProposalID}?page=${currentPage}`)}
                                                                                                className='m-auto text-center'
                                                                                                style={{
                                                                                                    width: "3.8rem", fontWeight: "600", padding: "7px 3px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
                                                                                                    background: 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
                                                                                                    color: 'white', borderRadius: '8px',
                                                                                                }}
                                                                                            > <img src='/view32.png' style={{ width: '0.9rem', height: "0.9rem", filter: 'brightness(0) invert(1)' }} />
                                                                                                View
                                                                                            </button>
                                                                                        </td>
                                  <td className="py-2">
                                    {technicalInwards.Work_name}
                                  </td>
                                  {userData?.RoleID !== 41 && (
                                    <th className="py-2">
                                      {technicalInwards.JOB_ID}
                                    </th>
                                  )}
                                  <td className='py-2'>{technicalInwards.Proposal_year}</td>
                                  <td className='py-2'>{technicalInwards.SchemeName}</td>
                                  <td className="py-2">
                                    {technicalInwards.District}
                                  </td>
                                  <td className='py-2 px-2'>
                                                                                    {technicalInwards.Gram_panchayat
                                                                                        ? JSON.parse(technicalInwards.Gram_panchayat).join(", ")
                                                                                        : ""}
                                                                                </td>
                                  <td className="py-2">
                                    {technicalInwards.classOfWork}
                                  </td>
                                  <td className="py-2 px-2">
                                    {technicalInwards.typeOfWork}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.roadCategory}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.roadNumber}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.proposedLength}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.workRemark}
                                  </td>
                                  <td className="py-2">{`${technicalInwards.Proposal_amount}`}</td>
                                  <td className="py-2">
                                    <button
                                      onClick={() =>
                                        Navigate(
                                          `/AdminDashboard/EditProposal/${technicalInwards.ProposalID}`,
                                          {
                                            state: {
                                              type: urlType,
                                            },
                                          },
                                        )
                                      }
                                      className="m-auto text-center"
                                      style={{
                                        width: "4rem",
                                        fontWeight: "700",
                                        padding: "7px 3px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "0.1rem",
                                        background:
                                          "linear-gradient(to right, #2E7D32, #43A047, #4CAF50, #66BB6A)",
                                        color: "white",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      {t("Edit")}
                                    </button>
                                  </td>
                                  <td style={{ padding: '8px' }}>
                                                                            <button
                                                                                onClick={() => nav(`/AdminDashboard/ShowMapProposal/${encodeURIComponent(technicalInwards.Work_name)}`)}
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    gap: '0.4rem',
                                                                                    padding: '6px 10px',
                                                                                    fontWeight: '700',
                                                                                    fontSize: '13px',
                                                                                    color: '#357EDC',
                                                                                    backgroundColor: '#E8F0FE',
                                                                                    borderRadius: '6px',
                                                                                    cursor: 'pointer',
                                                                                    transition: 'all 0.2s ease-in-out'
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src='/Go-To-Map32.png'
                                                                                    alt='Go to Map'
                                                                                    style={{ width: '1rem', height: '1rem' }}
                                                                                />
                                                                                Go to Map
                                                                            </button>
                                                                        </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table> */}

                      {/* /// Added New Table Design for Proposal Approval */}
                      <table
                        className="m-0 p-0"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          whiteSpace: "nowrap"
                        }}
                      >
                        <thead>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px"
                            }}
                          >
                            <th style={{ padding: "7px 10px", minWidth: "70px" }}>
                              Sr.No.
                            </th>

                            <th style={{ padding: "7px 10px", minWidth: "70px" }} >
                              <input
                                type="checkbox"
                                onChange={handleSelectAll}
                                checked={selectedBills.length > 0 && selectedBills.length === currentBills.length}
                                className='my-auto'
                                style={{ height: '1rem', width: '1rem' }}
                              />
                            </th>

                            <th style={{ padding: "7px 10px", minWidth: "120px" }}>
                              Proposal Year
                            </th>

                            <th style={{ padding: "7px 10px", minWidth: "250px" }}>
                              {t("Work Name")}
                            </th>

                            {/* <th style={{ padding: "7px 10px", minWidth: "120px" }}>
                                                                            Proposal Year
                                                                        </th> */}

                            <th style={{ padding: "7px 10px", minWidth: "150px" }}>
                              {t("District Name")}
                            </th>

                            {userData?.RoleID !== 41 && (
                              <th style={{ padding: "7px 10px", minWidth: "100px" }}>
                                Job ID
                              </th>
                            )}

                            <th style={{ padding: "7px 10px", minWidth: "140px" }}>
                              {t("Class Of Work")}
                            </th>

                            <th style={{ padding: "7px 10px", minWidth: "180px" }}>
                              {t("Type of Work")}
                            </th>

                            <th style={{ padding: "7px 10px", minWidth: "140px" }}>
                              {t("Road Number")}
                            </th>

                            <th style={{ padding: "7px 10px", minWidth: "140px" }}>
                              {t("Road Category")}
                            </th>

                            <th style={{ padding: "7px 10px", minWidth: "160px" }}>
                              {t("Proposed Length(in Km)")}
                            </th>

                            <th style={{ padding: "7px 10px", minWidth: "140px" }}>
                              {t("Work Amount")}
                            </th>

                            <th style={{ padding: "7px 10px", minWidth: "180px" }}>
                              {t("Remark")}
                            </th>

                            <th style={{ padding: "7px 10px", minWidth: "180px" }}>
                              {t("Status")}
                            </th>


                            <th style={{ padding: "7px 10px", minWidth: "100px" }}>
                              {t("Edit")}
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {currentBills.length <= 0 ? (
                            <tr>
                              <td
                                colSpan="15"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "#f9f9f9"
                                }}
                              >
                                {t("No data available")}
                              </td>
                            </tr>
                          ) : (
                            currentBills?.map((technicalInwards, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                              return (
                                <tr
                                  key={technicalInwards.ProposalID || index}
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "18px",
                                    fontWeight: "500"
                                  }}
                                >
                                  {/* Sr.No */}
                                  <td className="py-2">
                                    {index + 1}
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      className='my-auto'
                                      style={{ height: '1rem', width: '1rem' }}
                                      checked={selectedBills.includes(technicalInwards.ProposalID)}
                                      onChange={() => handleCheckboxChange(technicalInwards.ProposalID, technicalInwards.Work_name)}
                                    />
                                  </td>

                                  {/* Proposal year */}
                                  <td className="py-2">
                                    {technicalInwards.Proposal_year || "-"}
                                  </td>

                                  {/* Work Name */}
                                  <td className="py-2">
                                    {technicalInwards.Work_name || "-"}
                                  </td>

                                  {/* District Name */}
                                  <td className="py-2">
                                    {technicalInwards.District || "-"}
                                  </td>

                                  {/* Job ID */}
                                  {userData?.RoleID !== 41 && (
                                    <td className="py-2">
                                      {technicalInwards.JOB_ID || "-"}
                                    </td>
                                  )}

                                  {/* Class Of Work */}
                                  <td className="py-2">
                                    {technicalInwards.classOfWork || "-"}
                                  </td>

                                  {/* Type Of Work */}
                                  <td className="py-2">
                                    {technicalInwards.typeOfWork || "-"}
                                  </td>

                                  {/* Road Number */}
                                  <td className="py-2">
                                    {technicalInwards.roadNumber || "-"}
                                  </td>

                                  {/* Road Category */}
                                  <td className="py-2">
                                    {technicalInwards.roadCategory || "-"}
                                  </td>

                                  {/* Proposed Length */}
                                  <td className="py-2">
                                    {technicalInwards.proposedLength || "-"}
                                  </td>

                                  {/* Work Amount */}
                                 <td className="py-2">
  {technicalInwards.Proposal_amount != null &&
  technicalInwards.Proposal_amount !== ""
    ? `₹${Number(technicalInwards.Proposal_amount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "-"}
</td>

                                  {/* Status */}
                                  {/* <td className="py-2">
                                    {technicalInwards.workRemark || "-"}
                                  </td> */}
                                  <td className="py-2">
    {technicalInwards.Status === "SendBack"
        ? technicalInwards.Remark?.trim() || "-"
        : technicalInwards.workRemark?.trim() || "-"}
</td>

                                  {/* Status */}
                                  <td className="py-2">
                                    {technicalInwards.Status || "-"}
                                  </td>

                                  {/* Edit */}
                                  <td className="py-2">
                                    <button
                                      onClick={() =>
                                        Navigate(
                                          `/AdminDashboard/EditProposal/${technicalInwards.ProposalID}`,
                                          {
                                            state: {
                                              type: urlType
                                            }
                                          }
                                        )
                                      }
                                      className="m-auto text-center"
                                      style={{
                                        width: "4rem",
                                        fontWeight: "700",
                                        padding: "7px 3px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        background:
                                          "linear-gradient(to right, #2E7D32, #43A047, #4CAF50, #66BB6A)",
                                        color: "white",
                                        borderRadius: "4px"
                                      }}
                                    >
                                      {t("Edit")}
                                    </button>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                      {/* ////////////// */}


                    </div>
                  </div>

                  <div className="col-12 mt-3">
                    <div
                      className="my-2 d-flex justify-content-between align-items-center"
                      style={{ flexWrap: "wrap" }}
                    >
                      <p
                        className="text-gray-600"
                        style={{ fontSize: "18px", margin: 0 }}
                      >
                        {t("Showing")}{" "}
                        {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
                        {t("to")}{" "}
                        {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
                        {t("of")} {filteredBills?.length} {t("entries")}
                      </p>
                      <div
                        className="col-6"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                        }}
                      >
                        <GooglePagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={setCurrentPage}
                        />
                      </div>

                      <div
                        className="col-6 text-start"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        <button
                          onClick={() => approveorrejectSelected("Approved")}
                          disabled={selectedBills.length <= 0 ? true : loading}
                          className="ms-0"
                          // onClick={(e) => { SetGenerateToken(false) }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.3rem",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                            backgroundColor:
                              selectedBills.length <= 0
                                ? "rgba(141, 141, 141, 0.97)"
                                : "#39B54A",
                            color: "white",
                            borderRadius: "8px",
                            cursor:
                              selectedBills.length <= 0
                                ? "not-allowed"
                                : loading
                                  ? "not-allowed"
                                  : "pointer",
                          }}
                        >
                          <img
                            src="/Approve-Selected32.png"
                            style={{
                              width: "1rem",
                              height: "1rem",
                              filter: "brightness(0) invert(1)",
                            }}
                          />{" "}
                          {loading ? t("Processing...") : t("Approve Selected")}
                        </button>

                        <button
                          onClick={() => setRejectpanelhide(2)}
                          // onClick={(e) => { SetGenerateRejectToken(false) }}
                          disabled={selectedBills.length <= 0 ? true : loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.3rem",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                            background:
                              selectedBills.length <= 0
                                ? "rgba(141, 141, 141, 0.97)"
                                : "#C1272D",
                            color: "white",
                            borderRadius: "8px",
                            cursor:
                              selectedBills.length <= 0
                                ? "not-allowed"
                                : loading
                                  ? "not-allowed"
                                  : "pointer",
                          }}
                        >
                          <img
                            src="/Reject-Selected32.png"
                            style={{
                              width: "1rem",
                              height: "1rem",
                              filter: "brightness(0) invert(1)",
                            }}
                          />{" "}
                          {loading ? t("Processing...") : t("Reject Selected")}
                        </button>
                        {adminData.Role !== "Deputy Engineer" &&
                          adminData.Role !== "RDD Section Officer" && (
                            <button
                              onClick={() => setRejectpanelhide(3)}
                              disabled={
                                selectedBills.length <= 0 ? true : loading
                              }
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "3px",
                                margin: "12px",
                                padding: "8px 10px",
                                fontWeight: "600",
                                background:
                                  selectedBills.length <= 0
                                    ? "rgba(141, 141, 141, 0.97)"
                                    : "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                color: "white",
                                borderRadius: "8px",
                                cursor:
                                  selectedBills.length <= 0
                                    ? "not-allowed"
                                    : loading
                                      ? "not-allowed"
                                      : "pointer",
                              }}
                            >
                              <img
                                src="/Send-Back-Selected32.png"
                                style={{
                                  width: "1rem",
                                  height: "1rem",
                                  filter: "brightness(0) invert(1)",
                                }}
                              />{" "}
                              {loading
                                ? t("Processing...")
                                : t("Send Back Selected")}
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {SelectedOptions === "SendBack" && (
                <div
                  className="m-auto"
                  style={{
                    width: "98%",
                    backgroundColor: "white",
                    padding: "30px 30px",
                    boxShadow: "0px 0px 5px 1px #c7c9cc",
                    borderRadius: "20px",
                  }}
                >
                  <div
                    className="col-12 tableDesign"
                    style={{
                      background: "#2C78DB",
                      overflowX: "auto",
                      maxWidth: "100%",
                    }}
                  >
                    <table
                      className="m-0 p-0"
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      {/* <thead>
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3rem",
                            fontSize: "12px",
                          }}
                        >
                          <th style={{ width: "4%", textAlign: "center" }}>
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={
                                selectedBills.length > 0 &&
                                selectedBills.length === currentBills.length
                              }
                              className="my-auto"
                              style={{ height: "1rem", width: "1rem" }}
                            />
                          </th>
                          <th style={{ width: "10%" }}>{t("Edit")}</th>
                          <th style={headerStyle}>{t("Proposal Name")}</th>
                          <th style={headerStyle}>{t("HeadCode")}</th>
                          <th style={headerStyle}>{t("Proposal Year")}</th>
                          <th style={headerStyle}>{t("District")}</th>
                          <th style={headerStyle}>{t("Gram Panchayat")}</th>
                          <th style={headerStyle}>{t("Work amount")}</th>
                          <th style={headerStyle}>{t("Remark")}</th>
                        </tr>
                      </thead> */}

                      {/* /////////// */}
                      <thead>
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3rem",
                            fontSize: "18px"
                          }}
                        >
                          <th style={{ padding: "7px 10px", minWidth: "70px" }}>
                            Sr.No.
                          </th>

                          <th style={{ padding: "7px 10px", minWidth: "70px" }} >
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={selectedBills.length > 0 && selectedBills.length === currentBills.length}
                              className='my-auto'
                              style={{ height: '1rem', width: '1rem' }}
                            />
                          </th>

                          <th style={{ padding: "7px 10px", minWidth: "220px" }}>
                            Proposal Year
                          </th>

                          <th style={{ padding: "7px 10px", minWidth: "250px" }}>
                            {t("Work Name")}
                          </th>

                          <th style={{ padding: "7px 10px", minWidth: "150px" }}>
                            {t("District Name")}
                          </th>

                          {userData?.RoleID !== 41 && (
                            <th style={{ padding: "7px 10px", minWidth: "100px" }}>
                              Job ID
                            </th>
                          )}

                          <th style={{ padding: "7px 10px", minWidth: "140px" }}>
                            {t("Class Of Work")}
                          </th>

                          <th style={{ padding: "7px 10px", minWidth: "180px" }}>
                            {t("Type of Work")}
                          </th>

                          <th style={{ padding: "7px 10px", minWidth: "140px" }}>
                            {t("Road Number")}
                          </th>

                          <th style={{ padding: "7px 10px", minWidth: "140px" }}>
                            {t("Road Category")}
                          </th>

                          <th style={{ padding: "7px 10px", minWidth: "160px" }}>
                            {t("Proposed Length(in Km)")}
                          </th>

                          <th style={{ padding: "7px 10px", minWidth: "140px" }}>
                            {t("Work Amount")}
                          </th>

                          <th style={{ padding: "7px 10px", minWidth: "180px" }}>
                            {t("Remark")}
                          </th>

                          <th style={{ padding: "7px 10px", minWidth: "180px" }}>
                            {t("Status")}
                          </th>


                          <th style={{ padding: "7px 10px", minWidth: "100px" }}>
                            {t("Edit")}
                          </th>
                        </tr>
                      </thead>
                      {/* ///////////// */}
                      <tbody>
                        {currentBills.length <= 0 ? (
                          <tr>
                            <td
                              colSpan="15"
                              style={{
                                textAlign: "center",
                                padding: "20px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              {t("No data available")}
                            </td>
                          </tr>
                        ) : (
                          currentBills?.map((technicalInwards, index) => {
                            const bgColor =
                              index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                            return (
                              <tr style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "500" }} key={index}>
                                {/* Sr.No */}
                                <td className="py-2">
                                  {index + 1}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  <input
                                    type="checkbox"
                                    className="my-auto"
                                    style={{ height: "1rem", width: "1rem" }}
                                    checked={selectedBills.includes(
                                      technicalInwards.ProposalID,
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(
                                        technicalInwards.ProposalID,
                                        technicalInwards.Work_name,
                                      )
                                    }
                                  />
                                </td>
                                {/* <td className="py-2">
                                  <button
                                    onClick={() =>
                                      Navigate(
                                        `/AdminDashboard/EditProposal/${technicalInwards.ProposalID}`,
                                      )
                                    }
                                    className="m-auto text-center"
                                    style={{
                                      width: "4rem",
                                      fontWeight: "600",
                                      padding: "7px 3px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      gap: "0.1rem",
                                      background:
                                        "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                      color: "white",
                                      borderRadius: "4px",
                                    }}
                                  >
                                    {t("Edit")}
                                  </button>
                                </td>
                                <td className="py-2">
                                  {technicalInwards.Work_name}
                                </td>
                                <td className="py-2">
                                  {technicalInwards.HeadCode}
                                </td>
                                <td className="py-2">
                                  {technicalInwards.Proposal_year}
                                </td>
                                <td className="py-2">
                                  {technicalInwards.District}
                                </td>
                                <td className="py-2">
                                  {technicalInwards.Gram_panchayat}
                                </td>
                                <td
                                  style={{ padding: "8px" }}
                                >{`${technicalInwards.Proposal_amount}`}</td>
                                <td
                                  style={{ padding: "8px" }}
                                >{`${technicalInwards.Remark}`}</td> */}


                                {/* ///////////// */}
                                {/* Proposal year */}
                                <td className="py-2">
                                  {technicalInwards.Proposal_year || "-"}
                                </td>

                                {/* Work Name */}
                                <td className="py-2">
                                  {technicalInwards.Work_name || "-"}
                                </td>

                                {/* District Name */}
                                <td className="py-2">
                                  {technicalInwards.District || "-"}
                                </td>

                                {/* Job ID */}
                                {userData?.RoleID !== 41 && (
                                  <td className="py-2">
                                    {technicalInwards.JOB_ID || "-"}
                                  </td>
                                )}

                                {/* Class Of Work */}
                                <td className="py-2">
                                  {technicalInwards.classOfWork || "-"}
                                </td>

                                {/* Type Of Work */}
                                <td className="py-2">
                                  {technicalInwards.typeOfWork || "-"}
                                </td>

                                {/* Road Number */}
                                <td className="py-2">
                                  {technicalInwards.roadNumber || "-"}
                                </td>

                                {/* Road Category */}
                                <td className="py-2">
                                  {technicalInwards.roadCategory || "-"}
                                </td>

                                {/* Proposed Length */}
                                <td className="py-2">
                                  {technicalInwards.proposedLength || "-"}
                                </td>

                           {/* Work Amount */}
<td className="py-2">
  {technicalInwards.Proposal_amount != null &&
  technicalInwards.Proposal_amount !== ""
    ? `₹${Number(technicalInwards.Proposal_amount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "-"}
</td>

                                {/* Status */}
                                {/* <td className="py-2">
                                  {technicalInwards.workRemark || "-"}
                                </td> */}
                                <td className="py-2">
    {technicalInwards.Status === "SendBack"
        ? technicalInwards.Remark?.trim() || "-"
        : technicalInwards.workRemark?.trim() || "-"}
</td>

                                {/* Status */}
                                <td className="py-2">
                                  {technicalInwards.Status || "-"}
                                </td>

                                {/* Edit */}
                                <td className="py-2">
                                  <button
                                    onClick={() =>
                                      Navigate(
                                        `/AdminDashboard/EditProposal/${technicalInwards.ProposalID}`,
                                        {
                                          state: {
                                            type: urlType
                                          }
                                        }
                                      )
                                    }
                                    className="m-auto text-center"
                                    style={{
                                      width: "4rem",
                                      fontWeight: "700",
                                      padding: "7px 3px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      background:
                                        "linear-gradient(to right, #2E7D32, #43A047, #4CAF50, #66BB6A)",
                                      color: "white",
                                      borderRadius: "4px"
                                    }}
                                  >
                                    {t("Edit")}
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="col-12 mt-3">
                    <div
                      className="my-2 d-flex justify-content-between align-items-center"
                      style={{ flexWrap: "wrap" }}
                    >
                      <p
                        className="text-gray-600"
                        style={{ fontSize: "14px", margin: 0 }}
                      >
                        {t("Showing")}{" "}
                        {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
                        {t("to")}{" "}
                        {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
                        {t("of")} {filteredBills?.length} {t("entries")}
                      </p>
                      <div className="col-6 text-end">
                        {/* First Page Button */}
                        <button
                          onClick={() => setCurrentPage(1)}
                          disabled={currentPage === 1}
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            border: "1px solid lightgrey",
                            cursor: "pointer",
                            fontSize: "20px",
                            width: "2rem",
                          }}
                        >
                          &laquo;
                        </button>
                        {/* Previous Button */}
                        <button
                          onClick={() => setCurrentPage(currentPage - 1)}
                          disabled={currentPage === 1}
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            border: "1px solid lightgrey",
                            cursor: "pointer",
                            fontSize: "20px",
                            borderLeft: "none",
                            width: "2rem",
                          }}
                        >
                          &lt;
                        </button>

                        <button
                          style={{
                            background:
                              "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                            color: "white",
                            cursor: "pointer",
                            fontSize: "20px",
                            width: "2.4rem",
                            border: "1px solid lightgrey",
                            borderLeft: "none",
                          }}
                        >
                          {currentPage}
                        </button>
                        {/* Next Button */}
                        <button
                          onClick={() => setCurrentPage(currentPage + 1)}
                          disabled={currentPage === totalPages}
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            border: "1px solid lightgrey",
                            cursor: "pointer",
                            fontSize: "20px",
                            borderLeft: "none",
                            width: "2rem",
                          }}
                        >
                          &gt;
                        </button>
                        {/* Last Page Button */}
                        <button
                          onClick={() => setCurrentPage(totalPages)}
                          disabled={currentPage === totalPages}
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            border: "1px solid lightgrey",
                            cursor: "pointer",
                            fontSize: "20px",
                            borderLeft: "none",
                            width: "2rem",
                          }}
                        >
                          &raquo;
                        </button>
                      </div>

                      <div
                        className="col-6 text-start"
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        <button
                          onClick={() => approveorrejectSelected("Approved")}
                          disabled={selectedBills.length <= 0 ? true : loading}
                          className="ms-0"
                          // onClick={(e) => { SetGenerateToken(false) }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.3rem",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                            backgroundColor:
                              selectedBills.length <= 0
                                ? "rgba(141, 141, 141, 0.97)"
                                : "#39B54A",
                            color: "white",
                            borderRadius: "8px",
                            cursor:
                              selectedBills.length <= 0
                                ? "not-allowed"
                                : loading
                                  ? "not-allowed"
                                  : "pointer",
                          }}
                        >
                          <img
                            src="/Approve-Selected32.png"
                            style={{
                              width: "1rem",
                              height: "1rem",
                              filter: "brightness(0) invert(1)",
                            }}
                          />{" "}
                          {loading ? t("Processing...") : t("Approve Selected")}
                        </button>

                        <button
                          onClick={() => setRejectpanelhide(2)}
                          // onClick={(e) => { SetGenerateRejectToken(false) }}
                          disabled={selectedBills.length <= 0 ? true : loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.3rem",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                            background:
                              selectedBills.length <= 0
                                ? "rgba(141, 141, 141, 0.97)"
                                : "#C1272D",
                            color: "white",
                            borderRadius: "8px",
                            cursor:
                              selectedBills.length <= 0
                                ? "not-allowed"
                                : loading
                                  ? "not-allowed"
                                  : "pointer",
                          }}
                        >
                          <img
                            src="/Reject-Selected32.png"
                            style={{
                              width: "1rem",
                              height: "1rem",
                              filter: "brightness(0) invert(1)",
                            }}
                          />{" "}
                          {loading ? t("Processing...") : t("Reject Selected")}
                        </button>

                        {adminData.Role !== "Deputy Engineer" &&
                          adminData.Role !== "RDD Section Officer" && (
                            <button
                              onClick={() => setRejectpanelhide(3)}
                              disabled={
                                selectedBills.length <= 0 ? true : loading
                              }
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "3px",
                                margin: "12px",
                                padding: "8px 10px",
                                fontWeight: "600",
                                background:
                                  selectedBills.length <= 0
                                    ? "rgba(141, 141, 141, 0.97)"
                                    : "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                color: "white",
                                borderRadius: "8px",
                                cursor:
                                  selectedBills.length <= 0
                                    ? "not-allowed"
                                    : loading
                                      ? "not-allowed"
                                      : "pointer",
                              }}
                            >
                              <img
                                src="/Send-Back-Selected32.png"
                                style={{
                                  width: "1rem",
                                  height: "1rem",
                                  filter: "brightness(0) invert(1)",
                                }}
                              />{" "}
                              {loading
                                ? t("Processing...")
                                : t("Send Back Selected")}
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {rejectPanelhide === 2 && (
          <div className="col-12 RejectPanelContainer">
            <div className="Rejectpanel">
              <form action="">
                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3">
                      <label className="fw-bold">
                        {t("Remark")} <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-8">
                      <textarea
                        name=""
                        id=""
                        placeholder={t("Enter Remark")}
                        value={remark}
                        onChange={(e) =>
                          setRemark(e.target.value.replace(/^\s+/, ""))
                        }
                      ></textarea>
                    </div>
                  </div>
                </div>
              </form>
              <div className="col-12 ms-auto my-4">
                <div className="row">
                  <div className="col-9 m-auto">
                    <div
                      className="col-12"
                      style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                      }}
                    >
                      <button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "4px",
                          background:
                            "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                          width: "5rem",
                          height: "2rem",
                          fontSize: "18px",
                        }}
                        onClick={() => approveorrejectSelected("Rejected")}
                      >
                        <img src={submit} style={{ width: "15px" }} />{" "}
                        {t("Reject")}
                      </button>
                      <button
                        type="button"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "4px",
                          backgroundColor: "#f1594c",
                          width: "6rem",
                          height: "2rem",
                          fontSize: "16px",
                        }}
                        onClick={() => window.location.reload()}
                      >
                        {" "}
                        <img src={Cancel32} style={{ width: "17px" }} />
                        {t("Cancel")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {rejectPanelhide === 3 && (
          <div className="col-12 RejectPanelContainer">
            <div className="Rejectpanel">
              <form action="">
                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3">
                      <label className="fw-bold">
                        {t("Remark")} <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-8">
                      <textarea
                        name=""
                        id=""
                        placeholder={t("Enter Remark")}
                        value={remark}
                        onChange={(e) =>
                          setRemark(e.target.value.replace(/^\s+/, ""))
                        }
                      ></textarea>
                    </div>
                  </div>
                </div>
              </form>
              <div className="col-12 ms-auto my-4">
                <div className="row">
                  {/* <div className="col-3"></div> */}
                  <div className="col-9 m-auto">
                    <div
                      className="col-12"
                      style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                      }}
                    >
                      <button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "4px",
                          background:
                            "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                          width: "8rem",
                          height: "2rem",
                          fontSize: "18px",
                        }}
                        onClick={() => approveorrejectSelected("SendBack")}
                      >
                        <img src={submit} style={{ width: "15px" }} />{" "}
                        {t("Send Back")}
                      </button>
                      <button
                        type="button"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "4px",
                          backgroundColor: "#f1594c",
                          width: "6rem",
                          height: "2rem",
                          fontSize: "16px",
                        }}
                        onClick={() => window.location.reload()}
                      >
                        {" "}
                        <img src={Cancel32} style={{ width: "17px" }} />
                        {t("Cancel")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProposalApproval;
